"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerMobileTitle = void 0;
var React = require("react");
var PodcastPlayerMobileTitle = function (_a) {
    var title = _a.title, isRunning = _a.isRunning;
    return (React.createElement("div", { className: "podcast-player-mobile-title" },
        React.createElement("div", { className: "podcast-player-mobile-title__container " + (isRunning ? 'running' : '') },
            React.createElement("span", null, title),
            React.createElement("span", null, title))));
};
exports.PodcastPlayerMobileTitle = PodcastPlayerMobileTitle;
